import { Entry } from '../Entry'

export function Entry20211110() {
  return (
    <Entry title="10/11/2021 - v3.0.0-beta-11">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/12307/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
